import { type TemplateResult } from '@design.estate/dees-element';
import type { DeesChartDonut } from './component.js';

export const renderChartDonut = (component: DeesChartDonut): TemplateResult => {
  return component.renderChartFrame();
};
